import React, { useState, useEffect } from "react";
import { Card, Table, Tooltip, Button, Modal, Row, Col, message, Tag } from "antd";
import { PlusOutlined, DeleteFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import 'antd/dist/antd.css';
import PatronagerService from "../../../../../services/Election/Patronage/PatronagerService";
import ConfirmDelete from "../../../../../helpers/cards-helper/ConfirmDelete";
import { setFormFieldValue } from "../../../../../helpers/FormHelper";



const ReferredList = ({ dispatch, items, totalCount, initialPagination, isLoading, onAdd, onRefreshList }) => {
    const token = useSelector((state) => state.Member.token);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modalResetNumber, setModalResetNumber] = useState({ deleteModal: 0 });


    const initialPaginationTable = {
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    };


    const [paginationTable, setPaginationTable] = useState(
        initialPaginationTable
    );


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setPaginationTable({
            ...pagination,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            }
        };
        dispatch(action);
    };


    const openDeleteModal = (item) => {
        setItem(item);
        setDeleteModal(true);
    };


    const closeDeleteModal = () => {
        setItem(null);
        setDeleteModal(false);
        setModalResetNumber({
            ...modalResetNumber,
            deleteModal: modalResetNumber.deleteModal + 1
        });
    };


    const onDelete = () => {
        setLoading(true);
        PatronagerService.deleteReferred(token, item.id).then((response) => {
            message
                .success("Fshirja u krye me sukses!", 1).then(
                    onSuccess(),
                    closeDeleteModal(),
                    setLoading(false),
                );
        })
            .catch((err) => {
                const errorMessage = err.response.data.Error ? err.response.data.Error : "Një gabim ndodhi gjatë fshirjes!";
                message.error(errorMessage, 2);
                setLoading(false);
            });
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 60,
            render: (value) => <b>{value}.</b>,
        },
        {
            title: "Emri",
            dataIndex: "name",
            width: 120,
            render: (value) => value.toString().toUpperCase(),
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            width: 120,
            render: (value) => value.toString().toUpperCase(),
        },
        {
            title: "QV",
            dataIndex: "qv_code",
            align: "center",
            width: 100,
        },
        {
            title: "Nr. liste",
            dataIndex: "list_number",
            align: "center",
            width: 100,
        },
        {
            title: "Kod banese",
            dataIndex: "building_no",
            align: "center",
            width: 120,
        },
        {
            title: "Datelindja",
            dataIndex: "birthdate",
            align: "center",
            width: 120,
        },
        {
            title: "Telefoni",
            dataIndex: "phone",
            width: 150,
        },
        {
            title: "Referuesi",
            dataIndex: "referues",
            align: 'left',
            width: 200,
            render: (_, elm) => setFormFieldValue(elm?.referues)
        },
        {
            title: "Telefoni i referuesit",
            dataIndex: "referues_phone",
            align: 'left',
            width: 200,
            render: (_, elm) => setFormFieldValue(elm?.referues_phone)
        },
        {
            title: "Votoi",
            dataIndex: "voted",
            align: "center",
            width: 100,
            render: (_, elm) => (
                <Row gutter={24}>
                    <Col span={24}>

                        {elm?.voter?.voted === false && (
                            <Tag className="m-0" color="magenta">JO</Tag>
                        )}
                        
                        {elm?.voter?.voted === true && (
                            <Tag className="m-0" color="green">PO</Tag>
                        )}

                    </Col>
                </Row>
            ),
        },
        {
            title: "Veprime",
            dataIndex: "actions",
            align: "center",
            width: 100,
            render: (_, elm) => (
                <div style={{ fontSize: "20px" }}>
                    <Tooltip title="Fshi">
                        <Button
                            danger
                            onClick={() => openDeleteModal(elm)}
                            icon={<DeleteFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    const onSuccess = () => {
        onRefreshList();
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} align="middle">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className='text-left'>

                        {totalCount > 0 && (
                            <h4 className="m-0 p-0">{totalCount === 1 ? totalCount + " i referuar" : parseInt(totalCount).toLocaleString() + " të referuar"}</h4>
                        )}

                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className="text-right">
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={onAdd}
                        >
                            Shto të referuar
                        </Button>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    columns={tableColumns}
                                    rowKey="id"
                                    bordered="true"
                                    dataSource={items}
                                    pagination={paginationTable}
                                    loading={isLoading}
                                    onChange={handleTableChange}
                                    scroll={{ x: 1000 }}
                                    showHeader="true"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Jeni duke fshirë të referuarin e zgjedhur!"}
                            centered
                            visible={deleteModal}
                            onCancel={closeDeleteModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <ConfirmDelete
                                title={"Jeni të sigurtë që doni të fshini të referuarin: "}
                                fullName={item?.voter?.name + " " + item?.voter?.surname}
                                loading={loading}
                                onOk={onDelete}
                                onCancel={closeDeleteModal}
                            />
                        </Modal>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default ReferredList;